import React from 'react';
import { Users, Package2, ClipboardList, Bell, Search } from 'lucide-react';

function EmployeeDashboard() {
  return (
    <div className="min-h-screen bg-gray-50 pt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-2xl font-bold text-gray-900">Панель управления</h1>
          <p className="mt-1 text-sm text-gray-500">
            Добро пожаловать, Администратор
          </p>
        </div>

        {/* Search */}
        <div className="mb-8">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
            <input
              type="text"
              placeholder="Поиск заказов, клиентов..."
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#0171E3] focus:border-transparent"
            />
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
          {[
            { label: 'Активные заказы', value: '24', icon: Package2, color: 'bg-blue-500' },
            { label: 'Новые клиенты', value: '12', icon: Users, color: 'bg-green-500' },
            { label: 'Задачи', value: '8', icon: ClipboardList, color: 'bg-yellow-500' },
            { label: 'Уведомления', value: '3', icon: Bell, color: 'bg-red-500' }
          ].map((stat, index) => (
            <div key={index} className="bg-white rounded-lg shadow p-6">
              <div className="flex items-center">
                <div className={`${stat.color} rounded-full p-3`}>
                  <stat.icon className="w-6 h-6 text-white" />
                </div>
                <div className="ml-4">
                  <div className="text-2xl font-semibold text-gray-900">{stat.value}</div>
                  <div className="text-sm text-gray-500">{stat.label}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Main Content */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Recent Orders */}
          <div className="lg:col-span-2 bg-white rounded-lg shadow">
            <div className="p-6">
              <h2 className="text-lg font-medium text-gray-900 mb-4">Последние заказы</h2>
              <div className="space-y-4">
                {[...Array(5)].map((_, index) => (
                  <div key={index} className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                    <div>
                      <div className="font-medium">Заказ #{202400 + index}</div>
                      <div className="text-sm text-gray-500">Иван Иванов</div>
                    </div>
                    <div className="text-right">
                      <div className="text-[#0171E3]">¥ 2,500</div>
                      <div className="text-sm text-gray-500">2 часа назад</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Tasks */}
          <div className="bg-white rounded-lg shadow">
            <div className="p-6">
              <h2 className="text-lg font-medium text-gray-900 mb-4">Задачи на сегодня</h2>
              <div className="space-y-4">
                {[
                  'Проверить новые заказы',
                  'Связаться с поставщиком',
                  'Обновить статусы доставки',
                  'Подготовить отчет',
                  'Ответить на сообщения'
                ].map((task, index) => (
                  <div key={index} className="flex items-center">
                    <input
                      type="checkbox"
                      className="rounded border-gray-300 text-[#0171E3] focus:ring-[#0171E3]"
                    />
                    <span className="ml-3 text-gray-700">{task}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EmployeeDashboard;